import { useEffect } from 'react';

import {
  DashboardType,
  getInitialLandingURL,
  getPharmacistWorkshiftStatus,
  PharmacistLegendVariant,
  pharmacistResetValue,
  professionalWorkshiftStatus,
  setActiveDashboard,
  utilResetValue,
} from '@pharmaplan/common';
import LogoutHandler from '@pharmaplan/common/helpers/LogoutHandler';
import { allowedPaths, ScreenTypes } from '../helpers/Constants';
import { renderScreen, setOpen } from '../actions/drawerActions';

import { useAppDispatch } from './useAppDispatch';
import { useAppSelector } from './useAppSelector';
import useProfessional from './Professional/useProfessional';

const useHandleLandingUrls = () => {
  const dispatch = useAppDispatch();
  const landingUrl = useAppSelector(getInitialLandingURL);
  const { isProfessional } = useProfessional();
  const isUserLoggedIn = LogoutHandler.isUserLoggedIn();
  const workshiftStatus = useAppSelector(professionalWorkshiftStatus);

  const url = new URL(globalThis.location.href);
  const { pathname } = url ?? {};

  let parsedLandingURL = null;

  if (landingUrl) {
    parsedLandingURL = new URL(landingUrl);
  }

  const openDrawer = (type: PharmacistLegendVariant, id: string) => {
    dispatch(setOpen(true));
    dispatch(
      renderScreen({
        screenType: ScreenTypes.serviceWorkshiftDetails,
        screenNumber: 1,
        eventIds: [id ?? ''],
        type,
      }),
    );
    dispatch(utilResetValue(['initialLandingURL']));
  };

  useEffect(() => {
    if (
      isUserLoggedIn
      && isProfessional && ((parsedLandingURL?.pathname
        && allowedPaths.has(parsedLandingURL?.pathname))
        || allowedPaths.has(pathname))
    ) {
      const id = parsedLandingURL?.searchParams.get('id') ?? url?.searchParams.get('id');
      dispatch(getPharmacistWorkshiftStatus(id ?? ''));
      dispatch(setActiveDashboard(DashboardType.calendar));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [landingUrl, isUserLoggedIn]);

  useEffect(() => {
    if (workshiftStatus?.workshiftId) {
      const { bookingId, workshiftId, type } = workshiftStatus ?? {};
      dispatch(pharmacistResetValue(['workshiftStatus']));
      openDrawer(type, bookingId || workshiftId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workshiftStatus?.workshiftId]);
};

export default useHandleLandingUrls;
